<template>
  <input-field
    :value="value"
    :label="label"
    :placeholder="placeholder"
    :errors="errors"
    type="number"
    step="0.1"
    min="0"
    :disabled="disabled"
    @input="onInput"
    @focus="onFocus"
    @change="onChange"
    @blur="onBlur"
  />
</template>

<script>
import { InputField } from "@/components/form"

export default {
  name: "number-field",
  props: ["value", "label", "placeholder", "errors", "disabled"],
  components: {
    InputField
  },
  methods: {
    onInput(e) {
      this.$emit("input", e)
    },
    onChange(e) {
      this.$emit("change", e)
    },
    onFocus(e) {
      this.$emit("focus", e)
    },
    onBlur(e) {
      this.$emit("blur", e)
    }
  }
}
</script>
